import { render, staticRenderFns } from "./WaitingListCellRendererActions.vue?vue&type=template&id=28564c09&"
import script from "./WaitingListCellRendererActions.vue?vue&type=script&lang=js&"
export * from "./WaitingListCellRendererActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports